import {
  ANALYZE_PAGE_VIEW,
  ANALYZE_PRODUCT_NOT_FOUND_PAGE_VIEW,
  AnalyzePageViewAction,
  AnalyzeProductNotFoundPageViewAction,
} from 'b2b-apps/shop/analytics/redux';

const analyzePageView = (data: Record<string, any>): AnalyzePageViewAction => ({
  type: ANALYZE_PAGE_VIEW,
  payload: {
    data,
  },
});

const analyzeProductNotFoundPageView = (): AnalyzeProductNotFoundPageViewAction => ({
  type: ANALYZE_PRODUCT_NOT_FOUND_PAGE_VIEW,
});

export {
  analyzePageView,
  analyzeProductNotFoundPageView,
};
